module.exports = __webpack_public_path__ + "static/img/14000060.0ec8bc63.png";